/* eslint-disable */
let self;
let datalayer;
let event;
let page_path;
let target;
let page_type;
let content_type;
let content_group;
let content_variant;
let get_dataready;

export class Datalayer_click {
  constructor( datalayer_attr ) { // Receive part of the attributes to create the datalayer
    self = this;
    event = datalayer_attr.event;
    target = datalayer_attr.target;
    page_path = datalayer_attr.page_path;

    self.getDatalayerAttr();

    datalayer = {
      event: event,
      target: target,
      page: {
        page_path: page_path,
        page_type: page_type,
      },
      content_group: content_group,
      content_type: content_type,
      content_variant: content_variant,
    };

    // Create and push the datalayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ origin: null }); // Clear the previous origin object.
    window.dataLayer.push(datalayer);
  }

  getDatalayerAttr() {
    get_dataready = dataLayer.find(function (obj) {
      return obj.event === "data_ready"
    });
    page_type = get_dataready.page.page_type;
    content_group = get_dataready.content_group;
    content_type = get_dataready.content_type;
    content_variant = get_dataready.content_variant;
  }
}
